import { collectionGroup, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Returns latest quoteId for a given conversation, or null if none.
// Queries across all companies/*/quotes sub-collections using a collection group query.
export const getLatestQuoteForConversation = async (conversationId) => {
  if (!db || !conversationId) return null;
  try {
    const q = query(
      collectionGroup(db, 'quotes'),
      where('conversationId', '==', conversationId),
      orderBy('createdAt', 'desc'),
      limit(1)
    );
    const snap = await getDocs(q);
    if (snap.empty) return null;
    return snap.docs[0].id;
  } catch (e) {
    console.error('Failed to load latest quote for conversation', conversationId, e);
    return null;
  }
};
